export default "__VITE_ASSET__1216fed5__"